import "./createUpdate.js";
import "./details.js";


// WEBPACK FOOTER //
// ./src/pages/maintainRetailer/index.js